import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { agents } from './AgentProfile';
import './Header.css';

function Header({ userData }) {
  const { loginWithRedirect, logout, isAuthenticated, user } = useAuth0();
  const navigate = useNavigate();
  const [isAgentDropdownOpen, setIsAgentDropdownOpen] = useState(false);

  const handleAgentClick = (agentKey) => {
    navigate(`/agent/${agentKey}`);
    setIsAgentDropdownOpen(false);
  };

  return (
    <header className="Header">
      <div className="Header-left">
        <Link to="/" className="logo-link">
          <h1>Tangled</h1>
        </Link>
      </div>

      <nav className="Header-right">
        {/* About button - always visible */}
        <button
          className="btn btn-about"
          onClick={() => navigate('/about')}
        >
          About
        </button>

        {/*/!* MutantC60 button - always visible *!/*/}
        {/*<button*/}
        {/*  className="btn btn-bluebell"*/}
        {/*  onClick={() => navigate('/mutantc60')}*/}
        {/*>*/}
        {/*  Challenge*/}
        {/*</button>*/}

        {/* Tutorial button - always visible */}
        <button
          className="btn btn-tutorial"
          onClick={() => navigate('/tutorial')}
        >
          Tutorial
        </button>

        {/* Code button - always visible */}
        <button
          className="btn btn-bluebell"
          onClick={() => navigate('/buildagent')}
        >
          Create
        </button>

          {/* Blog button - always visible */}
        <button
          className="btn btn-about"
          onClick={() => window.open('https://www.snowdropquantum.com/tangledblog', '_blank')}
        >
          Blog
        </button>

        {/* Leaderboard button - always visible */}
        <button
          className="btn btn-leaderboard"
          onClick={() => navigate('/leaderboard')}
        >
          Leaderboard
        </button>

        {/* Quantum Agents Dropdown */}
        <div
          className="dropdown-container"
          onMouseEnter={() => setIsAgentDropdownOpen(true)}
          onMouseLeave={() => setIsAgentDropdownOpen(false)}
        >
          <button className="btn btn-agents">
            Quantum Agents ▾
          </button>
          {isAgentDropdownOpen && (
            <div className="dropdown-menu">
              {Object.entries(agents).map(([key, agent]) => (
                <button
                  key={key}
                  className="dropdown-item"
                  onClick={() => handleAgentClick(key)}
                >
                  {agent.name}
                </button>
              ))}
            </div>
          )}
        </div>


        {!isAuthenticated ? (
          <>
            <button
              className="btn btn-secondary"
              onClick={() => loginWithRedirect()}
            >
              Login
            </button>
            <button
              className="btn btn-primary"
              onClick={() => loginWithRedirect({
                authorizationParams: {
                  screen_hint: 'signup'
                }
              })}
            >
              Sign Up
            </button>
          </>
        ) : (
          <div className="user-menu">
            <span>Welcome, {userData?.username || user?.name}</span>
            {userData?.avatar_url && (
              <img
                src={userData.avatar_url}
                alt="Avatar"
                className="avatar-small"
              />
            )}

            <button
              className="btn-play"
              onClick={() => navigate('/play')}
            >
              Play
            </button>

            <button
              className="btn-dashboard"
              onClick={() => navigate('/dashboard')}
            >
              Dashboard
            </button>

            <button onClick={() => logout({ returnTo: window.location.origin })}>
              Logout
            </button>
          </div>
        )}
      </nav>
    </header>
  );
}

export default Header;